import { AxiosResponse } from "axios";
import API from "../api";
import { JobType } from "../models/jobType";

const endpoint = "types/jobs";

const JobTypeService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${endpoint}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<JobType[]>> {
    return await API.get(`/${endpoint}`, { params: options });
  },
  async create(jobType: JobType): Promise<AxiosResponse<JobType>> {
    return await API.post(`/${endpoint}`, jobType);
  },
  async update(id: number, jobType: JobType): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${endpoint}/${id}`, jobType);
  },
};

export default JobTypeService;
